import React from 'react';
import {
  Tag
} from 'antd';

const WEIGHT_LIMIT = 1000;
const WEIGHT_LIMIT_MAX = 1500;
const CARTON_RATE_LIMIT = 1.1;
export const chkPallet = (pkgs, singlePallet = false) => {
  let weights = 0;
  let cartons = [];
  let palletCount = 0;
  if (pkgs.length === 1) {
    if (pkgs[0].carton_count > pkgs[0].carton_count_per_pallet) {
      palletCount = pkgs[0].carton_count / pkgs[0].carton_count_per_pallet;
    }
  }
  if (singlePallet) palletCount = 1;
  (pkgs || []).forEach(x => {
    weights += x.weight;
    const find = cartons.find(c => c.goods_spec_id === x.goods_spec_id);
    if (find) {
      find.carton_count =  find.carton_count + x.carton_count;
      find.carton_rate = find.carton_count * 1.0 / x.carton_count_per_pallet;
    } else {
      cartons.push({
        goods_spec_id: x.goods_spec_id,
        carton_count_per_pallet: x.carton_count_per_pallet,
        carton_rate: x.carton_count * 1.0 / x.carton_count_per_pallet,
        carton_count: x.carton_count
      });
    }
  });
  let carton_rate = 0;
  cartons.forEach(x => {
    carton_rate += x.carton_rate;
  });
  if (palletCount > 1) {
    weights = weights /palletCount;
    carton_rate = carton_rate / palletCount;
  }
  let status = 0;
  const tags = [];
  if (weights > WEIGHT_LIMIT && weights <= WEIGHT_LIMIT_MAX) {
    tags.push(<Tag color="#FFA500">超重{(weights - WEIGHT_LIMIT).toFixed(2)}</Tag>)
    status = 1;
  } else if (weights > WEIGHT_LIMIT_MAX) {
    tags.push(<Tag color="#f50">超重{(weights - WEIGHT_LIMIT).toFixed(2)}</Tag>)
    status = 2;
  }

  if (carton_rate > CARTON_RATE_LIMIT) {
    tags.push(<Tag color="#f50">箱比{carton_rate.toFixed(2)}</Tag>)
    status = 2;
  } else {
    tags.push(<Tag color="#87d068">箱比{carton_rate.toFixed(2)}</Tag>)
  }
  if (status > 0) {
    return { status: status, content: <span>{tags}</span> }
  }
  return { status: status, content: <span><Tag color="#87d068">正常</Tag><Tag color="#87d068">箱比{carton_rate.toFixed(2)}</Tag></span> }
}

